import { useTranslation } from 'react-i18next';
import { ICON } from './icon';
import Collapse from '../Collapse';
import { Divider, Form, Input, Switch } from 'antd';
import { useState } from 'react';

const Content = ({ form }) => {
    const { t } = useTranslation();

    const [contentError, setContentError] = useState(false);
    const isDisplayCookiePolicy = Form.useWatch(
        ['isDisplayCookiePolicy'],
        form
    );
    const isDisplayPrivacyPolicy = Form.useWatch(
        ['isDisplayPrivacyPolicy'],
        form
    );

    const [hc, setHc] = useState(false);
    const [curl, setCurl] = useState(false);
    const [hp, setHp] = useState(false);
    const [purl, setPurl] = useState(false);

    const urlPattern = /^(http:\/\/|https:\/\/)/;

    const checkError = (_, value) => {
        if (value) {
            setContentError(false);
            return Promise.resolve();
        }
        setContentError(true);
        return Promise.reject(new Error(t('errorText.requiredField')));
    };

    const checkErrorHyperLink = (_, value) => {
        if (value) {
            setHc(false);
            return Promise.resolve();
        }
        setHc(true);
        return Promise.reject(new Error(t('errorText.requiredField')));
    };

    const checkErrorHyperLinkPrivacy = (_, value) => {
        if (value) {
            setHp(false);
            return Promise.resolve();
        }
        setHp(true);
        return Promise.reject(new Error(t('errorText.requiredField')));
    };

    const checkErrorUrl = (_, value, callback) => {
        if (!value) {
            setCurl(true);
            callback(t('errorText.requiredField'));
        } else if (value && !urlPattern.test(value)) {
            setCurl(true);
            callback('Please input in format http:// or https://');
        } else {
            setCurl(false);
            callback();
        }
    };

    const checkErrorUrlPrivacy = (_, value, callback) => {
        if (!value) {
            setPurl(true);
            callback(t('errorText.requiredField'));
        } else if (value && !urlPattern.test(value)) {
            setPurl(true);
            callback('Please input in format http:// or https://');
        } else {
            setPurl(false);
            callback();
        }
    };

    return (
        <div>
            <div className="text-[#999999] font-semibold text-xs uppercase">
                {t('Customize form')}
            </div>
            <div
                style={{ borderBottom: '1px solid #F2F2F2' }}
                className="w-full my-2"
            ></div>
            <div className="space-y-2">
                <Collapse
                    error={contentError}
                    icon={ICON.ONE}
                    title={t('COOKIE.BannerContent')}
                >
                    <Form.Item
                        name={['customizeContent', 'titleTh']}
                        label={
                            <span className="font-semibold mb-2 text-sm">
                                {t('COOKIE.TopicThai')}
                            </span>
                        }
                    >
                        <Input
                            placeholder={t('COOKIE.SpecifyInformationTH')}
                            size="large"
                        />
                    </Form.Item>
                    <Form.Item
                        name={['customizeContent', 'titleEn']}
                        label={
                            <span className="font-semibold mb-2 text-sm">
                                {t('COOKIE.TopicEng')}
                            </span>
                        }
                    >
                        <Input
                            placeholder={t('COOKIE.SpecifyInformationEN')}
                            size="large"
                        />
                    </Form.Item>
                    <Form.Item
                        name={['customizeContent', 'contentTh']}
                        label={
                            <span className="font-semibold mb-2 text-sm">
                                {t('COOKIE.TextThai')}
                            </span>
                        }
                        rules={[
                            {
                                validator: checkError,
                                required: true,
                            },
                        ]}
                    >
                        <Input.TextArea
                            placeholder={t('COOKIE.SpecifyInformationTH')}
                            size="large"
                            rows={3}
                        />
                    </Form.Item>
                    <Form.Item
                        name={['customizeContent', 'contentEn']}
                        label={
                            <span className="font-semibold mb-2 text-sm">
                                {t('COOKIE.TextEng')}
                            </span>
                        }
                        rules={[
                            {
                                validator: checkError,
                                required: true,
                            },
                        ]}
                    >
                        <Input.TextArea
                            placeholder={t('COOKIE.SpecifyInformationEN')}
                            size="large"
                            rows={3}
                        />
                    </Form.Item>
                </Collapse>
                <Collapse
                    error={[hc, curl, hp, purl].find(Boolean) ?? false}
                    icon={ICON.TWO}
                    title={t('COOKIE.Hyperlink')}
                >
                    <div className="flex justify-between items-center mb-4">
                        <div className="text-sm font-semibold">
                            {t('COOKIE.ShowCookiePolicy')}
                        </div>
                        <Form.Item
                            noStyle
                            name="isDisplayCookiePolicy"
                            valuePropName="checked"
                        >
                            <Switch />
                        </Form.Item>
                    </div>
                    {isDisplayCookiePolicy && (
                        <>
                            <Form.Item
                                label={
                                    <div className="font-semibold text-sm">
                                        {t('COOKIE.CookiePolicyName')}
                                    </div>
                                }
                                rules={[
                                    {
                                        validator: checkErrorHyperLink,
                                        required: true,
                                    },
                                ]}
                                name="hyperLinkDisplayCookieNameTh"
                                initialValue="นโยบายคุกกี้"
                            >
                                <Input addonBefore="TH" size="large" />
                            </Form.Item>
                            <Form.Item
                                rules={[
                                    {
                                        validator: checkErrorHyperLink,
                                        required: true,
                                    },
                                ]}
                                name="hyperLinkDisplayCookieNameEn"
                                initialValue="Cookie Policy"
                            >
                                <Input addonBefore="EN" size="large" />
                            </Form.Item>
                            <Form.Item
                                label={
                                    <div className="font-semibold text-sm">
                                        Cookie Policy URL
                                    </div>
                                }
                                rules={[
                                    {
                                        validator: checkErrorUrl,
                                        required: true,
                                    },
                                ]}
                                name="cookiePolicyUrlTh"
                            >
                                <Input
                                    addonBefore="TH"
                                    placeholder={t('COOKIE.PlaceholderURL')}
                                    size="large"
                                />
                            </Form.Item>
                            <Form.Item
                                rules={[
                                    {
                                        validator: checkErrorUrl,
                                        required: true,
                                    },
                                ]}
                                name="cookiePolicyUrlEn"
                            >
                                <Input
                                    addonBefore="EN"
                                    placeholder={t('COOKIE.PlaceholderURL')}
                                    size="large"
                                />
                            </Form.Item>
                        </>
                    )}
                    <Divider />
                    <div className="flex justify-between items-center mb-4">
                        <div className="text-sm font-semibold">
                            {t('COOKIE.ShowPrivacyPolicy')}
                        </div>
                        <Form.Item
                            noStyle
                            name="isDisplayPrivacyPolicy"
                            valuePropName="checked"
                        >
                            <Switch />
                        </Form.Item>
                    </div>
                    {isDisplayPrivacyPolicy && (
                        <>
                            <Form.Item
                                label={
                                    <div className="font-semibold text-sm">
                                        {t('COOKIE.PrivacyPolicyName')}
                                    </div>
                                }
                                rules={[
                                    {
                                        validator: checkErrorHyperLinkPrivacy,
                                        required: true,
                                    },
                                ]}
                                name="hyperLinkDisplayPrivacyNameTh"
                                initialValue="นโยบายความเป็นส่วนตัว"
                            >
                                <Input addonBefore="TH" size="large" />
                            </Form.Item>
                            <Form.Item
                                rules={[
                                    {
                                        validator: checkErrorHyperLinkPrivacy,
                                        required: true,
                                    },
                                ]}
                                name="hyperLinkDisplayPrivacyNameEn"
                                initialValue="Privacy Policy"
                            >
                                <Input addonBefore="EN" size="large" />
                            </Form.Item>
                            <Form.Item
                                label={
                                    <div className="font-semibold text-sm">
                                        Privacy Policy URL
                                    </div>
                                }
                                rules={[
                                    {
                                        validator: checkErrorUrlPrivacy,
                                        required: true,
                                    },
                                ]}
                                name="privacyPolicyUrlTh"
                            >
                                <Input
                                    addonBefore="TH"
                                    placeholder={t('COOKIE.PlaceholderURL')}
                                    size="large"
                                />
                            </Form.Item>
                            <Form.Item
                                rules={[
                                    {
                                        validator: checkErrorUrlPrivacy,
                                        required: true,
                                    },
                                ]}
                                name="privacyPolicyUrlEn"
                            >
                                <Input
                                    addonBefore="EN"
                                    placeholder={t('COOKIE.PlaceholderURL')}
                                    size="large"
                                />
                            </Form.Item>
                        </>
                    )}
                </Collapse>
            </div>
        </div>
    );
};

export default Content;
